'use strict';

const HeroHomeShape = {
    init: function () {
        const shape = document.querySelector('.f-herohome-cx__blur-mask');

        if (!shape) return;

        const updateClipPath = () => {
            if (window.innerWidth < 841) {
                shape.style.clipPath = '';
                return;
            }

            const width = shape.offsetWidth;

            const left = 240;
            const right = 240;

            const dx = width - left - right;
            const dy = Math.tan((25 * Math.PI) / 180) * dx;

            const scale = width / 1440;

            const leftOffsetY = -450 * scale;
            const rightOffsetY = 40 * scale;

            shape.style.clipPath = `
                polygon(
                    0 0,
                    0 100%,
                    ${left}px 100%,

                    ${left}px ${400 + dy + leftOffsetY}px,
                    ${width - right}px ${rightOffsetY}px,
                    ${width - right}px ${350 + rightOffsetY}px,
                    ${left}px ${750 + dy + leftOffsetY}px,

                    ${left}px 100%,
                    100% 100%,
                    100% 0
                )
            `;
        };

        updateClipPath();
        window.addEventListener('resize', updateClipPath);
    },
};

export default HeroHomeShape;
